// This file will eventually be auto generated.

// URL of external API Proxy service
// export const apiProxy = 'https://dlab01.services.ftl.corporate.t-mobile.com/proxy'

// Existing bundled api proxy. This will be removed after validation of external proxy.
export const apiProxy = '/api'
